exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".spinner-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  padding: 10px; }\n\n.col:has(.spinner-container),\n.col:has(.prime-table-container) {\n  min-height: 300px; }\n", ""]);

